// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_M-soI","waterfall":"waterfall_buq-W","g-list":"g-list","g-view-more-wrap":"g-view-more-wrap","g-view-more":"g-view-more"};